export const advisorEngagementStatuses = [
  { key: 'draft', title: 'Draft', colorPalette: 'gray' },
  { key: 'searching', title: 'Searching', colorPalette: 'blue' },
  { key: 'invited', title: 'Invited', colorPalette: 'orange' },
  { key: 'active', title: 'Active', colorPalette: 'green' },
  { key: 'ended', title: 'Ended', colorPalette: 'red' },
].map(x => ({ ...x, id: x.key }))

export const ADVISOR_ENGAGEMENT_STATUS_DRAFT = 'draft'
export const ADVISOR_ENGAGEMENT_STATUS_SEARCHING = 'searching'
export const ADVISOR_ENGAGEMENT_STATUS_INVITED = 'invited'
export const ADVISOR_ENGAGEMENT_STATUS_ACTIVE = 'active'
export const ADVISOR_ENGAGEMENT_STATUS_ENDED = 'ended'
